// Retired upload pages (Josh, 09/22/2026) — HIDDEN, not deleted.
//
// Every id listed here is (a) filtered out of the left nav in components/Layout.js and
// (b) its route in App.js becomes a redirect to RETIRED_REDIRECT_TO. The page components
// and their backend endpoints stay in the codebase, so un-retiring a page is a one-line
// removal from this list.
//
// Pre-check (workspace/part_c_queue_check.py, run 09/22/2026): upload_queues empty,
// sheet_sync_queue empty, no sheet-sync config → all four clear to retire.
//   - 'uploads'       owned routes/uploads.py fix queues (missing_deal / unmatched_bounce /
//                     unmatched_refund)
//   - 'sheet-import'  owned sheet_sync_queue (pending sheet changes)

export const RETIRED_REDIRECT_TO = '/daily-import-review';

export const RETIRED_PAGE_IDS = [
  'uploads',
  'bulk-import',
  'sheet-import',
  'mca-import',
];

// nav id -> route path(s) to redirect
export const RETIRED_PAGE_ROUTES = {
  'uploads': ['/uploads', '/uploads/history'],
  'bulk-import': ['/bulk-import'],
  'sheet-import': ['/sheet-import'],
  'mca-import': ['/mca-import'],
};

export const isRetired = (id) => RETIRED_PAGE_IDS.includes(id);

export const retiredRoutePaths = () =>
  RETIRED_PAGE_IDS.flatMap((id) => RETIRED_PAGE_ROUTES[id] || []);
